import ServicePageLayout from "@/pages/services/components/ServicePageLayout";

const relatedServices = [
  { label: "Membranes bitumineuses", href: "/services/membranes-bitumineuses" },
  { label: "Étanchéité liquide", href: "/services/etancheite-liquide" },
  { label: "Géomembranes EPDM", href: "/services/geomembranes-epdm" },
  { label: "Toitures-terrasses", href: "/services/toitures-terrasses" },
  { label: "Parkings (enrobés & asphalte)", href: "/services/parkings" },
];

export default function RefectionEtancheitePage() {
  return (
    <ServicePageLayout
      tag="Rénovation & réhabilitation"
      title="Réfection étanchéité"
      subtitle="Diagnostic, réhabilitation et réfection complète de systèmes d'étanchéité vieillissants ou défaillants pour toitures, parkings et ouvrages en Île-de-France."
      heroImage="https://readdy.ai/api/search-image?query=professional%20waterproofing%20renovation%20work%20on%20deteriorated%20flat%20rooftop%2C%20workers%20removing%20old%20bituminous%20membrane%20and%20preparing%20surface%20for%20new%20waterproofing%20system%2C%20construction%20site%2C%20professional%20BTP%20photography%2C%20wide%20angle%20view%2C%20overcast%20sky&width=1440&height=900&seq=ksbtp-re-hero-001&orientation=landscape"
      heroAlt="Réfection étanchéité KS BTP"
      intro="Un système d'étanchéité a une durée de vie limitée. Infiltrations, cloques, décollements, fissures ou vieillissement naturel des membranes : KS BTP intervient pour diagnostiquer précisément l'origine des désordres et proposer la solution de réfection la plus adaptée. Selon l'état du support, nous réalisons soit une réfection partielle ciblée (réparation des zones défaillantes), soit une réfection totale avec dépose de l'ancien système et mise en œuvre d'un nouveau complexe d'étanchéité. Nous intervenons sur toitures-terrasses, parkings, terrasses, balcons et ouvrages de génie civil."
      techItems={[
        { icon: "ri-search-eye-line", label: "Diagnostic & détection de fuites" },
        { icon: "ri-scissors-cut-line", label: "Dépose de l'ancien système" },
        { icon: "ri-hammer-line", label: "Réparation ciblée des zones défaillantes" },
        { icon: "ri-stack-line", label: "Réfection totale multicouche" },
        { icon: "ri-camera-line", label: "Thermographie infrarouge" },
        { icon: "ri-file-text-line", label: "Rapport de diagnostic détaillé" },
      ]}
      steps={[
        {
          number: "01",
          title: "Diagnostic complet",
          description: "Inspection visuelle, sondages, tests d'humidité et thermographie infrarouge pour localiser précisément les zones d'infiltration et évaluer l'état général.",
        },
        {
          number: "02",
          title: "Préconisation & devis",
          description: "Analyse des résultats, choix entre réfection partielle ou totale, sélection du système d'étanchéité adapté et établissement d'un devis détaillé.",
        },
        {
          number: "03",
          title: "Travaux de réfection",
          description: "Dépose de l'ancien revêtement si nécessaire, traitement du support, mise en œuvre du nouveau système d'étanchéité (bitume, EPDM ou résine liquide).",
        },
        {
          number: "04",
          title: "Contrôle & garantie",
          description: "Test d'étanchéité final, vérification de tous les points singuliers, remise du rapport d'intervention et du dossier de garantie décennale.",
        },
      ]}
      advantages={[
        "Diagnostic précis avec thermographie infrarouge pour localiser les infiltrations invisibles",
        "Réfection partielle ou totale selon l'état réel du support — pas de travaux inutiles",
        "Maîtrise de tous les systèmes : bitume, EPDM, résine liquide, asphalte",
        "Intervention rapide pour stopper les infiltrations actives et limiter les dégâts",
        "Rapport de diagnostic écrit remis avant tout engagement de travaux",
        "Garantie décennale sur les travaux de réfection réalisés",
        "Expérience sur tous types d'ouvrages : résidentiel, tertiaire, industriel, génie civil",
      ]}
      galleryImages={[
        {
          src: "https://readdy.ai/api/search-image?query=worker%20removing%20old%20deteriorated%20bituminous%20waterproofing%20membrane%20from%20flat%20rooftop%2C%20renovation%20work%2C%20peeling%20off%20aged%20black%20membrane%2C%20construction%20site%2C%20professional%20BTP%20photography&width=600&height=440&seq=ksbtp-re-gal-001&orientation=landscape",
          alt: "Dépose de l'ancienne membrane",
        },
        {
          src: "https://readdy.ai/api/search-image?query=infrared%20thermography%20inspection%20of%20flat%20rooftop%20to%20detect%20water%20infiltration%2C%20thermal%20camera%20showing%20heat%20map%20of%20wet%20insulation%20areas%2C%20professional%20building%20diagnostic%2C%20technical%20photography&width=600&height=440&seq=ksbtp-re-gal-002&orientation=landscape",
          alt: "Thermographie infrarouge pour détection de fuites",
        },
        {
          src: "https://readdy.ai/api/search-image?query=before%20and%20after%20rooftop%20waterproofing%20renovation%2C%20new%20black%20bituminous%20membrane%20applied%20on%20renovated%20flat%20roof%2C%20clean%20finished%20result%2C%20professional%20construction%20photography%2C%20modern%20building&width=600&height=440&seq=ksbtp-re-gal-003&orientation=landscape",
          alt: "Toiture rénovée après réfection complète",
        },
      ]}
      relatedServices={relatedServices}
    />
  );
}
